'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Components


// Helpers


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementUtil = require('../elementUtil');

var _ColorBar = require('../../components/colors/ColorBar');

var _ColorBar2 = _interopRequireDefault(_ColorBar);

var _LinkHeader = require('./LinkHeader');

var _LinkHeader2 = _interopRequireDefault(_LinkHeader);

var _LinkMetadata = require('./LinkMetadata');

var _LinkMetadata2 = _interopRequireDefault(_LinkMetadata);

var _Caption = require('../../components/caption/Caption');

var _Caption2 = _interopRequireDefault(_Caption);

var _ElementUserTag = require('../../user/userActivity/ElementUserTag');

var _ElementUserTag2 = _interopRequireDefault(_ElementUserTag);

var _LinkMedia = require('./richMedia/LinkMedia');

var _LinkMedia2 = _interopRequireDefault(_LinkMedia);

var _ElementResizeHandle = require('../resizing/ElementResizeHandle');

var _ElementResizeHandle2 = _interopRequireDefault(_ElementResizeHandle);

var _gridUtils = require('../../utils/grid/gridUtils');

var _elementCaptionUtil = require('../../components/caption/elementCaptionUtil');

var _elementConstants = require('../../../common/elements/elementConstants');

var _richMediaConstants = require('../../../common/links/richMediaConstants');

require('./Link.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Link = function Link(props) {
    var element = props.element,
        inList = props.inList,
        gridSize = props.gridSize,
        elementEvents = props.elementEvents,
        tempSize = props.tempSize,
        isLocked = props.isLocked,
        isEditable = props.isEditable;


    var classes = (0, _elementUtil.elementClassNames)('Link drag-handle', props);

    var colorName = element.get('content').get('color');
    var captionContent = (0, _elementCaptionUtil.getCaption)(element);
    var captionVisible = (0, _elementCaptionUtil.getShowCaption)(element);

    var mediaType = element.getIn(['content', 'mediaType']);
    var canResize = _richMediaConstants.RESIZEABLE_MEDIA.indexOf(mediaType) !== -1 && !isLocked && isEditable;
    var savedElementSize = element.getIn(['content', 'width']);
    var elementWidth = tempSize || savedElementSize || _elementConstants.ELEMENT_DEFAULT_WIDTH;

    var defaultMaxWidth = element.getIn(['content', 'media', 'width']);

    return _react2.default.createElement(
        'div',
        _extends({ id: (0, _elementUtil.getDomElementId)(element.get('id')),
            className: classes,
            style: (0, _gridUtils.getElementStyle)(elementWidth, gridSize, inList)
        }, elementEvents),
        _react2.default.createElement(_LinkMedia2.default, _extends({}, props, { width: elementWidth })),
        _react2.default.createElement(_ColorBar2.default, { colorName: colorName }),
        _react2.default.createElement(_ElementUserTag2.default, props),
        _react2.default.createElement(_LinkHeader2.default, props),
        _react2.default.createElement(_LinkMetadata2.default, props),
        _react2.default.createElement(_Caption2.default, _extends({}, props, {
            showDivider: true,
            textContent: captionContent,
            captionVisible: captionVisible })),
        _react2.default.createElement(_ElementResizeHandle2.default, _extends({}, props, { minWidth: _elementConstants.ELEMENT_DEFAULT_WIDTH, defaultMaxWidth: defaultMaxWidth,
            showHandle: canResize }))
    );
};

Link.propTypes = {
    element: _propTypes2.default.object.isRequired,
    gridSize: _propTypes2.default.number,
    inList: _propTypes2.default.string,
    isSelected: _propTypes2.default.bool,
    isEditing: _propTypes2.default.bool,
    isHovered: _propTypes2.default.bool,
    startEditing: _propTypes2.default.func,
    setEditHandler: _propTypes2.default.func,
    stopEditing: _propTypes2.default.func,
    saveContent: _propTypes2.default.func,
    handleKey: _propTypes2.default.func,
    className: _propTypes2.default.string,
    documentMode: _propTypes2.default.bool,
    elementEvents: _propTypes2.default.object,
    tempSize: _propTypes2.default.number,
    isLocked: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool
};

exports.default = Link;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/link/Link.js
// module id = 739
// module chunks = 0